import type { FC } from "react";
import {
  formatRelativeTime,
  type PlaybookSaveStatus,
} from "../hooks/usePlaybookSaveStatus.js";

interface PlaybookSaveStatusIndicatorProps {
  status: PlaybookSaveStatus;
}

/**
 * Displays the current save status for a playbook.
 * Shows "Saving changes..." or "Changes saved X ago".
 * Returns null when there are no changes.
 */
export const PlaybookSaveStatusIndicator: FC<
  PlaybookSaveStatusIndicatorProps
> = ({ status }) => {
  if (status.type === "no_changes") {
    return null;
  }

  const text =
    status.type === "saving"
      ? "Saving changes..."
      : `Saved ${formatRelativeTime(status.timestamp)}`;

  return <span className="text-xs text-muted-foreground">{text}</span>;
};
